import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { I18nModule } from '@app/i18n';
import { MaterialModule } from '@app/material.module';
import { AuthModule } from '@app/auth';
import { ShellComponent } from './shell.component';

import { SharedModule } from '@app/@shared';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';
import { NumberTranslatePipeModule } from '@app/@shared/pipes/number-translate/number-translate.module';
import { ChatbotComponent } from '@app/@shared/chatbot/chatbot.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    MaterialModule,
    AuthModule,
    I18nModule,
    RouterModule,
    NumberTranslatePipeModule,
  ],
  declarations: [ShellComponent, SettingMenuComponent, ChatbotComponent],
})
export class ShellModule {}
